function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { shortenUrl } from './ValueFormattersUrlHelpers';
// ----------------------------------------------------------------------
// Built-in formatters
// TODO: add params handling for formatters
// ----------------------------------------------------------------------
var linkFormatter = function linkFormatter(value) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var label = params.label;
  if (!label) {
    if (params.fullUrl === true) {
      label = value;
    } else {
      // defaults to shortened url (max 50 chars for default)
      label = shortenUrl(value);
    }
  }
  return "<a href=\"".concat(value, "\" rel=\"noreferrer noopener\" target=\"_blank\" title=\"").concat(value, "\">").concat(label, "</a>");
};
var imgFormatter = function imgFormatter(value) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // TODO: onError=replace with nicer placeholder? Maybe when refactoring to React?
  var img = "<img class=\"oskari_gfi_img\" src=\"".concat(value, "\"></img>");
  if (params.link === true) {
    return linkFormatter(value, {
      label: img
    });
  }
  return img;
};
// TODO: add decimal precision formatting etc localized formatting
var numberFormatter = function numberFormatter(value) {
  return value;
};
var phoneNumberFormatter = function phoneNumberFormatter(value) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return "<a href=\"tel:".concat(value, "\" title=\"").concat(value, "\">").concat(params.label || value, "</a>");
};

// Creates a formatter that takes value and wraps it in the html-element that was given as param when creating the formatter.
var tagWrapper = function tagWrapper(tag) {
  return function (value) {
    return "<".concat(tag, ">").concat(value, "</").concat(tag, ">");
  };
};

// ----------------------------------------------------------------------
// Formatter REGISTRY
// Note! other components can add or override formatters
// ----------------------------------------------------------------------

var DEFAULT_FORMATTER = '__default';
var formatters = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, DEFAULT_FORMATTER, function (value) {
  return value;
}), "link", linkFormatter), "image", imgFormatter), "number", numberFormatter), "phone", phoneNumberFormatter);
var tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'p', 'i', 'b', 'em'];
tags.forEach(function (tag) {
  formatters[tag] = tagWrapper(tag);
});
var hasFormatter = function hasFormatter(type) {
  return type && typeof formatters[type] === 'function';
};
var setFormatter = function setFormatter(type, func) {
  formatters[type] = func;
};
var getFormatter = function getFormatter(type) {
  if (hasFormatter(type)) {
    return formatters[type];
  }
  // return formatter that tries to detect the type from value
  return function (value) {
    var typeGuess = detectType(value);
    if (hasFormatter(typeGuess)) {
      return formatters[typeGuess](value);
    }
    // if we can't detect the formatter, return value as is
    return value;
  };
};
var detectType = function detectType(value) {
  if (!value) {
    return DEFAULT_FORMATTER;
  }
  if (typeof value === 'number') {
    return 'number';
  }
  if (typeof value === 'string') {
    var protocolSeparator = value.indexOf('://');
    if (protocolSeparator >= 0 && protocolSeparator < 10) {
      // protocol separator found "close enough" to the start -> format as link
      return 'link';
    }
  }
  return DEFAULT_FORMATTER;
};
export { getFormatter, setFormatter };